<template>
  <div class="d-inline-block" data-testid="help-menu">
    <v-menu :close-on-content-click="false" open-on-hover offset-y max-width="500" data-testid="help-menu__menu">
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on" class="help-icon" data-testid="help-menu__icon">
          {{ icon }}
        </v-icon>
      </template>
      <v-card>
        <div v-if="text" class="pa-4" data-testid="help-menu__text">
          {{text}}
        </div>
        <slot v-else name="text" data-testid="help-menu__slot-text" />
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
    };
  },
  // created() {
  //   this.refreshData();
  // },
  // activated() {
  //   this.refreshData();
  // },
  props: {
    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'mdi-help-circle-outline',
    },
  },
  methods:{

  }
};
</script>

